import React from 'react';
import { Route, Switch } from 'wouter';
import { useResolve } from './Container';
import { PassportModel } from './PassportModel';
import { useDashboardVersion } from './account/AccountHooks';
import { AccountModel } from './account/AccountModel';
import { AccountSwitch } from './account/AccountSwitch';
import { GuestSwitch } from './account/GuestSwitch';
import { NewAccountSwitch } from './account/NewAccountSwitch';
import { KioskPage } from './canvas/kiosk/KioskPage';
import { TemplatePreviewPage } from './dashboard/templates/TemplatePreviewPage';
import { BasicTutorialPage } from './onboarding/tutorials/TutorialPage';
import { SetupSwitch } from './setup/SetupSwitch';

const AccountSwitchSelector = () => {
    const account = useResolve(AccountModel);
    const passport = useResolve(PassportModel);
    const version = useDashboardVersion();
    if (account.active) {
        if (passport.has('da:read')) {
            if (version === 'next') {
                return <NewAccountSwitch key="acc" />;
            }
            else {
                return <AccountSwitch key="acc" />;
            }
        }
        else {
            return <GuestSwitch />;
        }
    }
    else {
        return <SetupSwitch />;
    }
};

export const AppSwitch = () =>
    <Switch>
        <Route path="/kiosk" component={KioskPage} />
        <Route path="/tutorial" component={BasicTutorialPage} />
        <Route path="/tp/:entityId" nest component={TemplatePreviewPage} />
        <Route path="/TP/:entityId" nest component={TemplatePreviewPage} />
        <Route path="*" component={AccountSwitchSelector} />
    </Switch>;
